export function KeyValueItem({ k, v }) {
  return (
    <div className="user_info_item">
      <span className="user_info_item_key">{k} :</span>
      <span className="user_info_item_value" data-tool-tip-top={v}>
        {v}
      </span>
    </div>
  );
}
